import "./Projects.css";

export default function ProjectCard({
  title,
  description,
  techStack,
  link,
  icon,
}) {
  return (
    <div className="project-card" onClick={() => window.open(link, "_blank")}>
      <div className="project-card-header">
        <div className="project-icon">{icon}</div>
        <h3 className="project-title">{title}</h3>
      </div>

      <div className="project-description">
        <p>{description}</p>
      </div>

      <div className="project-tech">
        {techStack.map((tech, index) => (
          <span key={index} className="tech-badge">
            {tech}
          </span>
        ))}
      </div>

      <div className="project-link">
        <span className="link-text">View Project →</span>
      </div>
    </div>
  );
}
